const React = require("react");
const logoUrl = require("../../../../assets/images/new_logo.png");

module.exports = () => <img alt="Book a street artist logo" style={{ width: 70, height: 70 }} src={logoUrl} />;
